import { combineReducers } from 'redux';

import hub from './hub/reducer';
import fileConfig from './fileconfig/reducer';
import common from './common/reducer';

export default combineReducers({
  hub,
  fileConfig,
  common,
});



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/reducer.js